import React from "react";

import Arrow from '../img/arrow.png';

const rightBar = {
  position: 'fixed',
  right: 0
}

const textScroll = {
  transform: 'rotate(-90deg)',
  fontFamily: 'Montserrat',
  fontSize: '13px',
  fontWeight: 300,
  fontStyle: 'normal',
  fontStretch: 'normal',
  lineHeight: 'normal',
  letterSpacing: '2.9px',
  textAlign: 'center',
  color: 'rgba(0, 0, 0, 0.87)'
}

class RightBar extends React.Component {
  render() {
    return (
      <div class="d-flex h-100" style = {rightBar}>
          <div class="justify-content-center align-self-center">
            <div class = '' style = {textScroll}>
               <span>Scroll</span>
            </div>
            <div class = '' style = {{paddingTop: '30px', paddingLeft: '20px'}}>
                <img src={Arrow} />
            </div>
          </div>
      </div>
    )
  }
}

export default RightBar;



// WEBPACK FOOTER //
// ./src/components/RightBar.js